import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInput from "../../../components/forms/CommonInput";
import {
  handleChange,
  handleChangeNameValue,
  handleChangeNumeral,
  handleChangeUnmask,
} from "../../../helpers/handleFormChanges";
import PropTypes from "prop-types";
import CommonInputMask from "../../../components/forms/CommonInputMask";
import CommonInputDate from "../../../components/forms/CommonInputDate";
import CommonInputValor from "../../../components/forms/CommonInputValor";
import CommonInputLink from "../../../components/forms/CommonInputLink";

function NovoMigracaoModal({
  modalHook,
  valuesHook,
  criarNovoProcesso,
  editar = false,
}) {
  const { values, setValues } = valuesHook;
  const { novoProcessoModal, setNovoProcessoModal } = modalHook;

  return (
    <CommonModal
      title={editar ? "Contrato" : "Novo processo de migração"}
      is_open_modal={novoProcessoModal}
      set_is_open_modal={setNovoProcessoModal}
      size="xl"
      buttons={
        <CommonButton
          key={`novo-processo`}
          color="success"
          onClick={criarNovoProcesso}
        >
          Salvar
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-lg-6 mb-3">
          {editar ? (
            <CommonInputLink
              label="Link do contrato"
              id="link_contrato"
              value={values.link_contrato}
              link={values.link_contrato}
              onChange={(e) => {
                handleChange(e, values, setValues);
              }}
              required
            />
          ) : (
            <CommonInput
              label="Link do contrato"
              id="link_contrato"
              value={values.link_contrato}
              onChange={(e) => {
                handleChange(e, values, setValues);
              }}
              required
            />
          )}
        </div>
        <div className="col-lg-2 mb-3">
          <CommonInputDate
            label="Data de assinatura"
            id="data_assinatura"
            value={values.data_assinatura}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
        <div className="col-lg-2 mb-3">
          <CommonInputValor
            label="Mensalidade"
            id="mensalidade"
            value={values.mensalidade}
            onChange={(e) => {
              handleChangeNameValue(
                "mensalidade",
                e.target.value,
                values,
                setValues
              );
            }}
            required
          />
        </div>
        <div className="col-lg-2 mb-3">
          <CommonInputDate
            label="Início do serviço"
            id="inicio_prestacao"
            value={values.inicio_prestacao}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-9 mb-3">
          <CommonInput
            label="Razão social"
            id="apelido_empresa"
            value={values.apelido_empresa}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
        <div className="col-lg-3 mb-3">
          <CommonInputMask
            label="CNPJ"
            id="cpf_empresa"
            value={values.cpf_empresa}
            onChange={(e) => handleChangeUnmask(e, values, setValues)}
            mask="99.999.999/9999-99"
            required
            disabled={editar}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-3 mb-3">
          <CommonInput
            label="Quantidade de sócios"
            id="numero_socios"
            value={values.numero_socios}
            onChange={(e) => {
              handleChangeNumeral(e, values, setValues);
            }}
            required
            disabled={editar}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <CommonInput
            label="E-mail"
            id="email_empresa"
            value={values.email_empresa}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
        <div className="col-lg-3 mb-3">
          <CommonInputMask
            label="Celular"
            id="celular_empresa"
            value={values.celular_empresa}
            onChange={(e) => handleChangeUnmask(e, values, setValues)}
            mask="(99) 99999-9999"
            required
          />
        </div>
      </div>
    </CommonModal>
  );
}

NovoMigracaoModal.propTypes = {
  modalHook: PropTypes.shape({
    novoProcessoModal: PropTypes.bool.isRequired,
    setNovoProcessoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  criarNovoProcesso: PropTypes.func.isRequired,
  editar: PropTypes.bool,
};

export default NovoMigracaoModal;
